export const FETCH_INVALIDATION_QUERY_KEYS = {
	fetchUser: "fetchUser",
	fetchEmployees: "fetchEmployees",
	fetchUsers: "allUsers",
	fetchEditedUser: "editedUser",
	fetchRegions: "allRegions",
	fetchCategoryId: "editedCategory",
	fetchCategories: "allCategories",
	map: "map",
	results: "results",
} as const;
